import React from 'react';
import { IMAGE_WITH_IN_PIXEL, IMAGE_HEIGHT_IN_PIXEL } from '~/config/constants';
import { alertSwal, htmlToBase64Picture } from '~/utils/helpers';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';

function ExportPictureButton({ cardFrontRef }) {
    const [processing, setProcessing] = React.useState(false);

    return (
        <Button
            className="bg-info border border-info btn btn-primary"
            onClick={async () => {
                try {
                    //create canvas with custom size. Ref: https://stackoverflow.com/a/33093629/11297747
                    const cardFrontElement = cardFrontRef.current;
                    setProcessing(true);

                    const base64String = await htmlToBase64Picture(
                        cardFrontElement,
                        IMAGE_WITH_IN_PIXEL,
                        IMAGE_HEIGHT_IN_PIXEL,
                    );

                    downloadImage(base64String);
                } catch (error) {
                    console.log('🚀 ~ error:', error);
                    alertSwal('error', `Cannot export picture: ${error}.`);
                } finally {
                    setProcessing(false);
                }
            }}
            disabled={processing}
        >
            {processing ? 'Exporting...' : 'Export'}
        </Button>
    );
}

const downloadImage = (base64String, fileName = 'sample-image') => {
    const fakeLink = window.document.createElement('a');
    fakeLink.style = 'display:none;';
    fakeLink.download = fileName;

    fakeLink.href = base64String;

    document.body.appendChild(fakeLink);
    fakeLink.click();
    document.body.removeChild(fakeLink);

    fakeLink.remove();
};

ExportPictureButton.propTypes = {
    cardFrontRef: PropTypes.object.isRequired,
};
export default ExportPictureButton;
